import React from 'react'
import { useShoppingCart } from '../../../context/CartContext.tsx/ShoppingCartContext'

const AddNewAddress = () => {

        
const { handleAddNewAddress } = useShoppingCart();

  return (
    <div>
     <div className='deliveryEstimateWrapper'>
                    <div className='deliveryEstimateWrapperContent'>
                        <div className='deliveryDate'>
                            <div>
                                <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.12 7.45C17.07 2.83 13.04 0.75 9.49997 0.75C9.49997 0.75 9.49997 0.75 9.48997 0.75C5.95997 0.75 1.91997 2.82 0.869973 7.44C-0.300027 12.6 2.85997 16.97 5.71997 19.72C6.77997 20.74 8.13997 21.25 9.49997 21.25C10.86 21.25 12.22 20.74 13.27 19.72C16.13 16.97 19.29 12.61 18.12 7.45ZM9.49997 12.46C7.75997 12.46 6.34997 11.05 6.34997 9.31C6.34997 7.57 7.75997 6.16 9.49997 6.16C11.24 6.16 12.65 7.57 12.65 9.31C12.65 11.05 11.24 12.46 9.49997 12.46Z" fill="#469DA1" />
                                </svg>
                            </div>
                            <div>
                                <div className='deliveryAddressWrap'>
                                    <span className='deliveryText'>Delivering to: </span>
                                    
                                    <input type="text" />
                                </div>
                                <div className='deliveryAddressWrap'>
                                    {/* <div className='firstAddress'>Add Address </div> */}
                                </div>
                            </div>
                        </div>
                        {/* <button onClick={() => { handleModal(true) }} >Change</button> */}
                        <div className='firstAddress'  onClick={handleAddNewAddress}>Add Address </div>

                    </div>

                </div>
    </div>
  )
}

export default AddNewAddress
